export default __webpack_public_path__ + "static/media/bloombergLogo.1b251a95.svg";